import { FC } from "react";
import { PauseCircle } from "lucide-react";
import { Button } from "src/components/ui/button";

interface Props {
	observedUser: string;
	formName: string;
	resume: () => void;
	onObserveAnotherUser?: () => void;
}

const PausedForm: FC<Props> = ({
	observedUser,
	formName,
	resume,
	onObserveAnotherUser
}) => {
	return (
		<div className="flex flex-1 justify-center">
			<div className="flex flex-col items-center gap-2">
				<div className="flex flex-col items-center gap-2 my-8">
					<PauseCircle size={64} data-testid="pause-circle-icon" />

					<p className="text-sm">{formName}</p>

					<p className="font-bold">
						Observation for {observedUser} has been paused.
					</p>

					<p className="text-sm text-foreground/60">
						If not resumed within 24 hours the observation will automatically
						closed.
					</p>
				</div>

				<Button
					type="button"
					onClick={resume}
					className="w-full"
					variant="outline"
				>
					Resume observation
				</Button>

				<Button type="button" className="w-full" onClick={onObserveAnotherUser}>
					{window.ReactNativeWebView ? "Close" : "Start a new observation"}
				</Button>
			</div>
		</div>
	);
};

export default PausedForm;
